import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { SESSION_STORAGE, Util } from '@phdsoft/common';
import { Subject } from 'rxjs';
import * as SignalR from '@microsoft/signalr';
import { environment } from 'src/environments/environment';
import { SensorChartComponent } from '../sensors/sensor-chart/sensor-chart.component';
import { SensorDataPair } from 'projects/phdsoft/common/src/lib/models/sensor-data-pair.model';


export interface IotMsgObject {
  hubName : string;
  groupId : string;
  payload : string;
}

const url = environment.API_IOT_FUNCTIONS.REALTIME_STREAM;

@Injectable({
  providedIn: 'root'
})

export class IotRTSignalRService {

  //phdDeviceMsg: Subject<IotMsgObject> = new Subject();
  private connections: { [hubName: string] : SignalR.HubConnection; } = {};
  private sensorChart : SensorChartComponent;
  private dataPair: SensorDataPair;

  constructor(private http: HttpClient) {
  }

  public async startConnection(assetId: string, userId: string, hubName: string, deviceMsg : Subject<IotMsgObject>) {
    this.connections[hubName] = new SignalR.HubConnectionBuilder()
      .configureLogging(SignalR.LogLevel.Information)
      .withUrl(url, {
          headers: {
            "user-id": userId,
            "hubname": hubName
          }
          ,accessTokenFactory: () => this.getAcessToken()
      })
      .build();

    this.connections[hubName]
        .start()
        .then(
          () => {
            console.log(`Connected signalR ${hubName}!`)

          },
          () => {
            console.log(`Error connecting signalR ${hubName}!`)
          }
        )
        .then(
          () => {
              this.http
              .post(`${url}addToGroup`, null, {
                //TODO: get asset device id's loop through them
                headers: {
                  "user-id": userId,
                  "group-id": assetId,
                  "hubname": hubName
                }
            })
              .subscribe();
          }
        )
        .catch((err) => console.log(`👎 Error while starting signalR ${hubName} connection: ${err}`));


        this.connections[hubName].on('notify', data => {
          console.log(data);
          deviceMsg.next(data);
        });

        this.connections[hubName].onclose((error) => {
          console.log(`SignalR connection closed. Error: ${error}`);
        });

        this.connections[hubName].onreconnecting((error) => {
          console.log(`SignalR connection reconnecting. Error: ${error}`);
        });

        this.connections[hubName].onreconnected((connectionId) => {
          console.log(`SignalR connection reconnected. ConnectionId: ${connectionId}`);
        });
    }



    public stopConnection(hubName: string): void {
        if (!Util.isNullOrUndefined(this.connections[hubName])) {
            this.connections[hubName].stop();
            delete this.connections[hubName];
        }
    }

    public stopAllConnections(): void {
        Object.entries(this.connections).forEach(
            ([key, value]) => this.stopConnection(key)
        );
    }

    public getAcessToken(){
      return localStorage[SESSION_STORAGE.TOKEN];
    }

}
